/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/categories": {
    /**
     * A category describes a type of place, such as "movie theater" or "zoo".
     * The places service has over 1,000 categories (or types) of place. The
     * categories fall into ten general groups: Arts and Entertainment, Business
     * and Professional Services, Community and Government, Dining and Drinking,
     * Events, Health and Medicine, Landmarks and Outdoors, Retail, Sports and
     * Recreation, and Travel and Transportation.
     *
     * The categories are organized into a hierarchical system where a general
     * category contains many more detailed variations on the parent category.
     * For example: "Travel and Transportation" (Level 1),
     * "Transport Hub" (Level 2), "Airport" (Level  3) and "Airport Terminal"
     * (Level 4). The hierarchy has up to 5 levels of categories.
     *
     * The table below shows the top-level of categories, along with a
     * selection of level two categories.
     *
     * The `/categories` endpoint fetches the latest set of place categories.
     * The request returns all categories including their label and
     * `categoryId`. You should use this endpoint to fetch the latest set of
     * categories when your app starts up. Each category contains an unique ID
     * that you can use to perform a `near-point` or `within-extent` search.
     *
     * You can also reduce the list to a subset of categories using the
     * `filter` parameter. For example, searching for "coffee" would return
     * categories including:
     *
     * - "Coffee Shop"
     *
     * - "Coffee Roaster"
     *
     * - "Turkish Coffeehouse"
     *
     * |Category Label | Category ID | Level 2|
     * |--- | --- | ---|
     * |Arts and Entertainment | 10000 | Amusement Park (10001), Art Gallery (10004), Casino (10008), Exhibit (10016), Movie Theater (10024), Museum (10027), Stadium (10051), Water Park (10055), Zoo (10056), ...|
     * |Business and Professional Services | 11000 | Construction (11028), Convention Center (11029), Food and Beverage Service (11056), Health and Beauty Service (11061), Industrial Estate (11106), Office (11124), ...|
     * |Community and Government | 12000 | Education (12009), Organization (12082), Government Building (12064), Community Center (12004), Library (12080), Utility Company (12115), ...|
     * |Dining and Drinking | 13000 | Bakery (13002), Bar (13003), Cafe, Coffee, and Tea House (13032), Restaurant (13065, ...|
     * |Event | 14000 |  Conference (14001), Convention (14002), Entertainment Event (14003), Marketplace (14009), ...|
     * |Health and Medicine | 15000 | Dentist (15007), Emergency Service (15008), Hospital (15014), Medical Center (15016), Optometrist (15024), Physician (15027), Veterinarian (15054), ...|
     * |Landmarks and Outdoors | 16000 | Beach (16003), Structure (16007), Campground (16008), Harbor or Marina (16018), Historic and Protected Site (16020), Monument (16026), Nature Preserve (16028), Park (16032), ...|
     * |Retail | 17000 | Arts and Crafts Store (17003), Bookstore (17018), Convenience Store (17029), Department Store (17033)|
     * |Sports and Recreation | 18000 | Athletic Field (18001), Baseball (18002), Basketball (18006), Football (18013), Golf (18016), Gym and Studio (18021), ...|
     * |Travel and Transportation | 19000 | Bike Rental (19002), Cruise (19005), Electric Vehicle Charging Station (19006), Fuel Station (19007), Lodging (19009), Transport Hub (19030), ...|
     *
     * **Note**: Category details are subject to change as new types of places
     * are introduced.
     *
     * **Note**: Query parameters are case-sensitive.
     */
    get: operations["categoriesGet"];
  };
  "/categories/{categoryId}": {
    /**
     * The `/categories/{categoryId}` request returns all the groups to which the category belongs. You must supply a `category ID` to use this request.
     *
     * **Note**: Query parameters are case-sensitive.
     */
    get: operations["categoriesCategoryIdGet"];
  };
  "/places/near-point": {
    /**
     * The `/places/near-point` request finds places that are within a given
     * radius of a specified location. The returned places contain basic data
     * such as name, category and location.
     *
     * To perform the request, you must supply the `x` and `y` coordinates of
     * the point from which to search. Optionally, you can also specify the:
     *
     * - Search radius (1 to 10,000 meters)
     * - Category IDs
     * - Search text
     *
     * If the `pagination.nextUrl` property in the response is populated, then
     * you can page through the results to return more places. The maximum
     * number of places that can be paged to is 200.
     *
     * **Note**: You cannot permanently store places. Please see the [Terms of
     * use](https://developers.arcgis.com/documentation/mapping-apis-and-services/deployment/terms-of-use/).
     *
     * **Note**: Query parameters are case-sensitive.
     */
    get: operations["nearPointGet"];
  };
  "/places/within-extent": {
    /**
     * The `/places/within-extent` request searches for places within an extent (bounding box).
     *
     * You must supply the `xmin`, `ymin`, `xmax` and `ymax` coordinates to
     * define the extent. The maximum width and height of an extent that can be
     * used in a search is 20,000 meters. The width and height of an extent
     * must be greater than 0 meters.
     *
     * You can also provide multiple categories or search text to find specific
     * types of places within the extent.
     *
     * The default number of places returned (`pageSize`) is 10. The maximum
     * `pageSize` value is 20.
     *
     * If the `pagination.nextUrl` property in the response is populated, then
     * you can page through the results to return more places. The maximum
     * number of places that can be paged to is 200.
     *
     * **Note**: You cannot permanently store places. Please see the [Terms of
     * use](https://developers.arcgis.com/documentation/mapping-apis-and-services/deployment/terms-of-use/).
     *
     * **Note**: Query parameters are case-sensitive.
     */
    get: operations["withinExtentGet"];
  };
  "/places/{placeId}": {
    /**
     * The `/places/{placeId}` request returns details for a place.
     *
     * To request details, you use the `requestedFields` parameter to specify
     * the fields and the attributes you want from the **Place**,
     * **Address**, **Details** and/or **Location** price groups.
     *
     * It is always recommended to specify the fields you want, however, you
     * can also use `requestedFields=all` to return all of the attributes
     * available. By default, The `placeId` attribute is always returned in addition
     * to the other attributes you requested.
     *
     * The attributes available for places may vary. For example, opening hours
     * may not be available (or applicable) for geographic places or landmarks.
     *
     * You will only be charged for attributes that contain valid values for
     * the requested fields. If no data is available for the requested field,
     * `null` or an empty collection  is returned and you are not charged. You
     * are only charged once if one or more attributes with valid values are
     * returned from a price group. To learn more, go to
     * [Pricing](https://developers.arcgis.com/pricing/).
     *
     * Field | Price group
     * --- | ---
     * additionalLocations:dropOff | Location
     * additionalLocations:frontDoor | Location
     * additionalLocations:road | Location
     * additionalLocations:roof | Location
     * address:adminRegion | Address
     * address:censusBlockId | Address
     * address:country | Address
     * address:designatedMarketArea | Address
     * address:extended | Address
     * address:locality | Address
     * address:neighborhood | Address
     * address:poBox | Address
     * address:postcode | Address
     * address:postTown | Address
     * address:region | Address
     * address:streetAddress | Address
     * categories | Place
     * chains | Details
     * contactInfo:email | Details
     * contactInfo:fax | Details
     * contactInfo:telephone | Details
     * contactInfo:website | Details
     * description | Details
     * hours:opening | Details
     * hours:openingText | Details
     * hours:popular | Details
     * location | Location
     * name | Place
     * rating:price | Details
     * rating:user | Details
     * socialMedia:facebookId | Details
     * socialMedia:instagram | Details
     * socialMedia:twitter | Details
     *
     * **Note**: You cannot permanently store places. Please see the [Terms of
     * use](https://developers.arcgis.com/documentation/mapping-apis-and-services/deployment/terms-of-use/).
     *
     * **Note**: Query parameters are case-sensitive.
     *
     * **Note**: Can be used in conjunction with the [Basemap Styles service](https://developers.arcgis.com/rest/basemap-styles) to request additional attributes
     * for places retrieved using the [Places for basemaps](https://developers.arcgis.com/documentation/mapping-apis-and-services/maps/places-for-basemaps) workflow.
     */
    get: operations["placeIdGet"];
  };
}

export interface components {
  schemas: {
    /**
     * @description An ID that uniquely identifies a place.
     *
     * A place ID is a 32 character string.
     *
     * @example 2da082218b6f7538e52250999c8f8ef1
     */
    PlaceId: string;
    /**
     * @description A result of searching for places using a `places/near-point` request.
     *
     * The result object includes a single place that satisfied the search and
     * the distance from the search point, in meters.
     */
    NearPointResult: {
      /**
       * @description The unique Id of this place.
       *
       * This place Id can be passed to the `places/{placeId}` endpoint to
       * retrieve additional details.
       *
       * @example 2da082218b6f7538e52250999c8f8ef1
       */
      placeId: components["schemas"]["PlaceId"];
      /**
       * @description The location of this place as a WGS84 point.
       *
       * @example {
       *   "x": -117.194769,
       *   "y": 34.057289
       * }
       */
      location: components["schemas"]["Point"];
      /**
       * @description A list of category objects for a place.
       *
       * Categories are uniquely identified by a `categoryId`. For example,
       * `17119` identifies a "Bicycle Store" and `10051` identifies a
       * "Stadium". Note that a single place can belong to multiple
       * categories (for example, a petrol station could also have a
       * super-market).
       *
       * @example [
       *   {
       *     "categoryId": "11167",
       *     "label": "Technology Business"
       *   }
       * ]
       */
      categories: components["schemas"]["Category"][];
      /**
       * @description The name of the place, or point of interest.
       * You can search for places by name using the `searchText` property in
       * a `places/near-point` or `places/within-extent` request.
       *
       * @example Esri International
       */
      name: string;
      /**
       * @description The distance, in meters, from the place to the search point of a 'places/near-point` query.
       *
       * @example 50
       */
      distance: number;
      /**
       * @description Details of an icon, suitable for depicting this place.
       *
       * To fetch icon details use the `icon` query parameter.
       */
      icon?: components["schemas"]["IconDetails"];
    };
    /**
     * @description A result of searching for places using a `places/within-extent` request.
     *
     * The result object includes a single place that satisfied the search.
     */
    WithinExtentResult: {
      /**
       * @description The unique Id of this place.
       *
       * This place Id can be passed to the `places/{placeId}` endpoint to
       * retrieve additional details.
       *
       * @example 2da082218b6f7538e52250999c8f8ef1
       */
      placeId: components["schemas"]["PlaceId"];
      /**
       * @description The location of this place as a WGS84 point.
       *
       * @example {
       *   "x": -117.194769,
       *   "y": 34.057289
       * }
       */
      location: components["schemas"]["Point"];
      /**
       * @description A list of category objects for a place.
       *
       * Categories are uniquely identified by a `categoryId`. For example,
       * `17119` identifies a "Bicycle Store" and `10051` identifies a
       * "Stadium". Note that a single place can belong to multiple
       * categories (for example, a petrol station could also have a
       * super-market).
       *
       * @example [
       *   {
       *     "categoryId": "11167",
       *     "label": "Technology Business"
       *   }
       * ]
       */
      categories: components["schemas"]["Category"][];
      /**
       * @description The name of the place, or point of interest.
       * You can search for places by name using the `searchText` property in
       * a `places/near-point` or `places/within-extent` request.
       *
       * @example Esri International
       */
      name: string;
      /**
       * @description Details of an icon, suitable for depicting this place.
       *
       * To fetch icon details use the `icon` query parameter.
       */
      icon?: components["schemas"]["IconDetails"];
    };
    /**
     * @description The additional details for a `Place`, including address, contact details, opening hours, and rating.
     *
     * You can request additional details for a place by using the `placeId` in
     * a `places/{placeId}` request. Use the `requestedFields` query parameter
     * to choose the fields or attributes that are included in the response.
     */
    PlaceDetails: {
      /**
       * @description The unique Id of this place.
       *
       * @example 2da082218b6f7538e52250999c8f8ef1
       */
      placeId: components["schemas"]["PlaceId"];
      /**
       * @description A list of category objects for a place.
       *
       * Categories are uniquely identified by a `categoryId`. For example,
       * `17119` identifies a "Bicycle Store" and `10051` identifies a
       * "Stadium". Note that a single place can belong to multiple
       * categories (for example, a petrol station could also have a
       * super-market).
       *
       * This property is part of the "Place" attribute group.
       *
       * @example [
       *   {
       *     "categoryId": "11167",
       *     "label": "Technology Business"
       *   }
       * ]
       */
      categories?: components["schemas"]["Category"][];
      /**
       * @description The name of the place, or point of interest.
       *
       * This property is part of the "Place" attribute group.
       *
       * @example Esri International
       */
      name?: string;
      /**
       * @description The location of this place as a WGS84 point.
       *
       * This property is part of the "Location" attribute group.
       *
       * @example {
       *   "x": -117.194769,
       *   "y": 34.057289
       * }
       */
      location?: components["schemas"]["Point"];
      /**
       * @description A text description of the place.
       *
       * This property is part of the "Details" attribute group.
       *
       * @example Esri is the global market leader in geographic information system
       * (GIS) technology, location intelligence, mapping software, and
       * spatial analytics. Esri software is deployed in more than 350,000
       * organizations and 75 percent of Fortune 500 companies.
       */
      description?: string | null;
      /**
       * @description The address of the place or point of interest (POI).
       *
       * This object and child properties are part of the "Address" attribute
       * group.
       */
      address?: components["schemas"]["Address"];
      /**
       * @description A set of additional locations that represent the place as WGS84 points, for example the location of the front door, or of a drop off point.
       *
       * This object and child properties are part of the "Location"
       * attribute group.
       */
      additionalLocations?: components["schemas"]["AdditionalLocations"];
      /**
       * @description Contact information for the place, such as the telephone number or email address.
       *
       * This object and child properties are part of the "Details" attribute
       * group.
       */
      contactInfo?: components["schemas"]["ContactInfo"];
      /**
       * @description Social media information associated with the place.
       *
       * This object and child properties are part of the "Details" attribute
       * group.
       */
      socialMedia?: components["schemas"]["SocialMedia"];
      /**
       * @description The operating hours for the place, including hours of opening and popular times.
       *
       * This object and child properties are part of the "Details" attribute
       * group.
       */
      hours?: components["schemas"]["Hours"];
      /**
       * @description Rating information supplied by users of the place.
       *
       * This object and child properties are part of the "Details" attribute
       * group.
       */
      rating?: components["schemas"]["Rating"];
      /**
       * @description Information about all the chains the place belongs to.
       *
       * This object and child properties are part of the "Details" attribute
       * group.
       *
       * @example [
       *   {
       *     "name": "Starbucks"
       *   }
       * ]
       */
      chains?: components["schemas"]["ChainInfo"][];
      /**
       * @description Details of an icon, suitable for depicting this place.
       *
       * To fetch icon details use the `icon` query parameter.
       */
      icon?: components["schemas"]["IconDetails"];
    };
    /** @example 17119 */
    CategoryId: string;
    /**
     * @description Represents the category of a place.
     *
     * You can get more information on categories from the `places/categories`
     * endpoint.
     */
    Category: {
      /**
       * @description The category Id uniquely identifies this category or type of place.
       *
       * The name of the category can be looked up using the
       * `places/categories` endpoint. For example, "17119" is the id for a
       * "Bicycle Store".
       *
       * @example 17119
       */
      categoryId: components["schemas"]["CategoryId"];
      /**
       * @description The label that describes the category.
       *
       * @example Bicycle Store
       */
      label: string;
    };
    /**
     * @description Provides details about a category or type of place.
     *
     * Categories are hierarchical so that you can filter places based on
     * specific categories such as "Provençal Restaurant", or with more generic
     * types such as "Restaurant". A category such as "Provençal Restaurant"
     * includes the details of its more generic parent, such as "French
     * Restaurant".
     */
    CategoryDetails: {
      /**
       * @description A unique identifying string for a category.
       *
       * This matches the `categoryId` of a place's `category` property.
       *
       * @example 17119
       */
      categoryId: components["schemas"]["CategoryId"];
      /** @description The full list of labels that describe the category, including its more generic parent categories. */
      fullLabel: string[];
      /** @description The list of parent category Ids for this category. */
      parents?: string[];
      /**
       * @description Details of an icon, suitable for depicting this place.
       *
       * To fetch icon details use the `icon` query parameter.
       */
      icon?: components["schemas"]["IconDetails"];
    };
    /**
     * Format: double
     * @description An x-coordinate, or longitude, in WGS84 decimal degrees.
     * @example -117.194769
     */
    XCoord: number;
    /**
     * Format: double
     * @description A y-coordinate, or latitude, in WGS84 decimal degrees.
     * @example 34.057289
     */
    YCoord: number;
    /**
     * Format: float
     * @description A search distance in meters.
     *
     * @default 1000
     * @example 50
     */
    SearchDistance: number;
    /**
     * @description A point defined in WGS84 decimal degrees.
     *
     * @example {
     *   "x": -117.194769,
     *   "y": 34.057289
     * }
     */
    Point: {
      /** @description The x, or longitude, of this location in WGS84 decimal degrees. */
      x: components["schemas"]["XCoord"];
      /** @description The y, or latitude, of this location in WGS84 decimal degrees. */
      y: components["schemas"]["YCoord"];
    };
    /**
     * @description A point defined in WGS84 decimal degrees.
     *
     * @example {
     *   "x": -117.194769,
     *   "y": 34.057289
     * }
     */
    NullablePoint: {
      /** @description The x, or longitude, of this location in WGS84 decimal degrees. */
      x: components["schemas"]["XCoord"];
      /** @description The y, or latitude, of this location in WGS84 decimal degrees. */
      y: components["schemas"]["YCoord"];
    } | null;
    /**
     * @description A pair of times defining the start and end of a time period.
     *
     * For example, this could define opening hours or popular hours. Hours are
     * shown in 24-hour time in the local timezone of the place or POI.
     *
     * Where a time range is 24-hours (for example a venue that is open 24-hours),
     * the `from` property will be 00:00 and the `to` property will be 23:59.
     *
     * @example {
     *   "from": "10:00",
     *   "to": "13:00"
     * }
     */
    TimeRange: {
      /**
       * @description The start of a time range in the format "HH:MM".
       * @example 09:00
       */
      from: string;
      /**
       * @description The end of a time range in the format "HH:MM".
       * @example 15:30
       */
      to: string;
    };
    /**
     * @description The opening or popular hours for a place.
     *
     * Opening hours are shown by day of the week. Each day can have several
     * pairs of from and to times. For example, if a coffee shop is open from
     * 9:00 until 12:00 and then again from 13:00 until 17:00, it would contain
     * two pairs of opening/closing times: 9:00 paired with 12:00 and 13:00
     * with 17:00. Hours are shown in 24-hour time in the local timezone of the
     * place or POI.
     */
    HoursByDay: {
      /**
       * @example [
       *   {
       *     "from": "09:00",
       *     "to": "17:00"
       *   }
       * ]
       */
      monday?: components["schemas"]["TimeRange"][];
      /**
       * @example [
       *   {
       *     "from": "09:00",
       *     "to": "17:00"
       *   }
       * ]
       */
      tuesday?: components["schemas"]["TimeRange"][];
      /**
       * @example [
       *   {
       *     "from": "09:00",
       *     "to": "12:00"
       *   },
       *   {
       *     "from": "13:00",
       *     "to": "17:00"
       *   }
       * ]
       */
      wednesday?: components["schemas"]["TimeRange"][];
      /**
       * @example [
       *   {
       *     "from": "09:00",
       *     "to": "17:00"
       *   }
       * ]
       */
      thursday?: components["schemas"]["TimeRange"][];
      /**
       * @example [
       *   {
       *     "from": "09:00",
       *     "to": "17:00"
       *   }
       * ]
       */
      friday?: components["schemas"]["TimeRange"][];
      /**
       * @example [
       *   {
       *     "from": "10:00",
       *     "to": "17:00"
       *   }
       * ]
       */
      saturday?: components["schemas"]["TimeRange"][];
      /**
       * @example [
       *   {
       *     "from": "11:00",
       *     "to": "12:00"
       *   }
       * ]
       */
      sunday?: components["schemas"]["TimeRange"][];
    } | null;
    /**
     * @description Lists the opening hours of this place or POI along with the popular or busy hours.
     *
     * A string is also provided that can be used for display.
     */
    Hours: {
      /**
       * @description The opening hours for a place.
       *
       * Opening hours are shown by day of the week. Each day can have
       * several pairs of from and to times. For example, if a coffee shop is
       * open from 9:00 until 12:00 and then again from 13:00 until 17:00, it
       * would contain two pairs of from/to times: 09:00 paired with 12:00
       * and 13:00 with 17:00. Opening hours are shown in 24-hour time in the
       * local timezone of the place or POI.
       *
       * @example {
       *   "monday": [
       *     {
       *       "from": "09:00",
       *       "to": "17:00"
       *     }
       *   ],
       *   "tuesday": [
       *     {
       *       "from": "09:00",
       *       "to": "17:00"
       *     }
       *   ],
       *   "wednesday": [
       *     {
       *       "from": "09:00",
       *       "to": "12:00"
       *     },
       *     {
       *       "from": "13:00",
       *       "to": "17:00"
       *     }
       *   ],
       *   "thursday": [
       *     {
       *       "from": "09:00",
       *       "to": "17:00"
       *     }
       *   ],
       *   "friday": [
       *     {
       *       "from": "09:00",
       *       "to": "17:30"
       *     }
       *   ],
       *   "saturday": [
       *     {
       *       "from": "10:00",
       *       "to": "17:00"
       *     }
       *   ],
       *   "sunday": [
       *     {
       *       "from": "11:00",
       *       "to": "12:00"
       *     }
       *   ]
       * }
       */
      opening?: components["schemas"]["HoursByDay"];
      /**
       * @description The popular or busy hours for a place.
       *
       * Popular hours are shown by day of the week. Each day can have
       * several pairs of from and to times. For example, if a coffee shop is
       * popular from 9:00 until 10:00 and then again from 14:00 until 15:00,
       * it would contain two pairs of from/to times: 09:00 paired with 10:00
       * and 14:00 with 15:00. Popular hours are shown in 24-hour time in the
       * local timezone of the place or POI.
       *
       * @example {
       *   "monday": [
       *     {
       *       "from": "10:00",
       *       "to": "12:00"
       *     },
       *     {
       *       "from": "14:00",
       *       "to": "15:00"
       *     }
       *   ],
       *   "tuesday": [
       *     {
       *       "from": "14:00",
       *       "to": "15:00"
       *     }
       *   ],
       *   "wednesday": [
       *     {
       *       "from": "10:00",
       *       "to": "12:00"
       *     },
       *     {
       *       "from": "14:00",
       *       "to": "15:00"
       *     }
       *   ],
       *   "thursday": [
       *     {
       *       "from": "14:00",
       *       "to": "15:00"
       *     }
       *   ],
       *   "friday": [
       *     {
       *       "from": "15:00",
       *       "to": "17:00"
       *     }
       *   ],
       *   "saturday": [
       *     {
       *       "from": "10:00",
       *       "to": "12:00"
       *     }
       *   ],
       *   "sunday": [
       *     {
       *       "from": "11:00",
       *       "to": "12:00"
       *     }
       *   ]
       * }
       */
      popular?: components["schemas"]["HoursByDay"];
      /**
       * @description The opening hours for this place, formatted for display.
       *
       * @example Mon-Thu 12:00 PM-11:00 PM; Fri-Sat 12:00 PM-11:30 PM; Sun 12:00 PM-10:30 PM
       */
      openingText?: string | null;
    };
    /** @description Rating information about the price and user rating of the place. */
    Rating: {
      /**
       * @description An indication of the overall price of a place based on user reviews.
       *
       * @example cheap
       * @enum {string|null}
       */
      price?: ("cheap" | "moderate" | "expensive" | "veryExpensive") | null;
      /**
       * Format: float
       * @description A rating for the place based on user-reviews from 0 to 5, where 5 is the best rating.
       *
       * @example 4.5
       */
      user?: number | null;
    };
    /**
     * @description A set of additional locations for the place, as WGS84 points.
     *
     * This list provides alternative locations for accessing a place such as
     * `frontDoor` or `road`.
     */
    AdditionalLocations: {
      /**
       * @description A location for drop-off/pick-up for a place.
       *
       * @example {
       *   "x": -0.279541,
       *   "y": 51.556057
       * }
       */
      dropOff?: components["schemas"]["NullablePoint"];
      /**
       * @description A location for the front door for a place.
       *
       * @example {
       *   "x": -0.279541,
       *   "y": 51.556057
       * }
       */
      frontDoor?: components["schemas"]["NullablePoint"];
      /**
       * @description A road-side location for a place.
       *
       * @example {
       *   "x": -0.279541,
       *   "y": 51.556057
       * }
       */
      road?: components["schemas"]["NullablePoint"];
      /**
       * @description A location in the roof centroid for a place.
       *
       * @example {
       *   "x": -0.279541,
       *   "y": 51.556057
       * }
       */
      roof?: components["schemas"]["NullablePoint"];
    };
    /** @description The address of a place, or point of interest (POI). */
    Address: {
      /**
       * @description The street address for a place, for example the street name and number.
       *
       * @example 380 New York St
       */
      streetAddress?: string | null;
      /**
       * @description Additional address information, including suite or apartment numbers.
       *
       * @example Unit 32
       */
      extended?: string | null;
      /**
       * @description The city, town, or equivalent.
       * @example Redlands
       */
      locality?: string | null;
      /**
       * @description As defined by Nielsen, signifies a region where the population can receive similar TV and radio offerings (US only).
       *
       * @example Los Angeles
       */
      designatedMarketArea?: string | null;
      /**
       * @description The state, province, territory or equivalent.
       *
       * @example CA
       */
      region?: string | null;
      /**
       * @description Postal code or equivalent (zip code in the US).
       *
       * Format will be localized based on country.
       *
       * @example 92373
       */
      postcode?: string | null;
      /** @description Post-office box. */
      poBox?: string | null;
      /**
       * @description Two letter ISO country code
       * @example US
       */
      country?: string | null;
      /**
       * @description Additional sub-division.
       *
       * Usually, but not always, a country sub-division (e.g., Scotland).
       *
       * @example Scotland
       */
      adminRegion?: string | null;
      /**
       * @description Town/place employed in postal addressing.
       *
       * @example Edinburgh
       */
      postTown?: string | null;
      /**
       * @description The neighborhoods of the place.
       *
       * @example [
       *   "Downtown"
       * ]
       */
      neighborhood?: string[];
      /**
       * @description The census block Id of the place (US only).
       *
       * @example 060710081003002
       */
      censusBlockId?: string | null;
    };
    /** @description The social media details for a place. */
    SocialMedia: {
      /**
       * @description The facebook Id of the place.
       * @example 183768242996
       */
      facebookId?: string | null;
      /**
       * @description The twitter handle of the place.
       * @example esri
       */
      twitter?: string | null;
      /**
       * @description The instagram ID of the place.
       * @example esrigram
       */
      instagram?: string | null;
    };
    /** @description The contact information for a place. */
    ContactInfo: {
      /**
       * @description The telephone number of the place.
       * @example (909) 793-2853
       */
      telephone?: string | null;
      /**
       * Format: url
       * @description The website address of the place.
       * @example https://www.esri.com
       */
      website?: string | null;
      /**
       * @description Fax number.
       * @example 0800 169 2008
       */
      fax?: string | null;
      /**
       * @description Email address.
       * @example support@esri.com
       */
      email?: string | null;
    };
    /** @description Information about a chain that a place belongs to. */
    ChainInfo: {
      /**
       * @description The name of the chain.
       *
       * @example Starbucks
       */
      name?: string | null;
    };
    /** @description Provides pagination links for accessing more results for the current request. */
    Pagination: {
      /**
       * Format: url
       * @description A url for fetching the previous page of results.
       *
       * Use this property to request the previous page of results if
       * available. If this property is omitted then there are no previous
       * pages of results. You must also supply authentication details, such
       * as a `token`, to make a previous page request.
       *
       * @example https://places-api.arcgis.com/arcgis/rest/services/places-service/v1/places/near-point?x=-117.194769&y=34.057289&radius=50.0&offset=0&pageSize=10
       */
      previousUrl?: string;
      /**
       * Format: url
       * @description A url for fetching the next page of results.
       *
       * Use this property to request the next page of results if available. If
       * this property is omitted then there are no more pages of results
       * available. You must also supply authentication details, such as a
       * `token`, to make a next page request.
       *
       * @example https://places-api.arcgis.com/arcgis/rest/services/places-service/v1/places/near-point?x=-117.194769&y=34.057289&radius=50.0&offset=20&pageSize=10
       */
      nextUrl?: string;
    };
    Error: {
      /** @description Error information */
      error: {
        /**
         * @description A code identifying the type of error.
         *
         * This can be an HTTP status code, `498` (invalid or expired
         * token), or `499` (missing token).
         *
         * @example 400
         * @enum {integer}
         */
        code: 400 | 401 | 403 | 404 | 498 | 499 | 500;
        /**
         * @description A message describing the error.
         * @example Parameter invalid.
         */
        message: string;
        /** @description List of details about the error. */
        details?: string[];
        /**
         * Format: url
         * @description A link to general information about the service, such as the owning system and token service URL.
         *
         * This property is only
         * present for errors relating to tokens.
         *
         * @example https://places-api.arcgis.com/arcgis/rest/info
         */
        restInfoUrl?: string;
      };
    };
    /** @description Information about an icon for depicting a place or category. */
    IconDetails: {
      /**
       * Format: url
       * @description Url for an icon for this place or category in either `svg`, `cim` or `png` format.
       *
       * @example https://static.arcgis.com/icons/places/Default_Shop_or_Service_15.svg
       */
      url?: string;
    };
  };
  responses: {
    /** Authentication Error. The API key or token is missing, invalid or expired. */
    UnauthorizedErrorResponse: {
      content: {
        "application/json": components["schemas"]["Error"];
      };
    };
    /** An error occurred on the server. */
    ServerErrorResponse: {
      content: {
        "application/json": components["schemas"]["Error"];
      };
    };
    /** Invalid query parameters. */
    InvalidQueryErrorResponse: {
      content: {
        "application/json": components["schemas"]["Error"];
      };
    };
    /** A resource with the supplied Id was not found. */
    IdNotFoundErrorResponse: {
      content: {
        "application/json": components["schemas"]["Error"];
      };
    };
    /** The required parameter 'token' is valid but does not have permission to access the service. */
    PermissionMissingErrorResponse: {
      content: {
        "application/json": components["schemas"]["Error"];
      };
    };
    /** A successful request to return details for a single category. */
    CategoryDetailsResponse: {
      content: {
        "application/json": components["schemas"]["CategoryDetails"];
      };
    };
    /** Details of categories that a `Place` can belong to. */
    CategoriesDetailsResponse: {
      content: {
        "application/json": {
          categories: components["schemas"]["CategoryDetails"][];
        };
      };
    };
    /** A successful response for a `places/near-point` request. */
    NearPointResponse: {
      content: {
        "application/json": {
          results: components["schemas"]["NearPointResult"][];
          pagination?: components["schemas"]["Pagination"];
        };
      };
    };
    /** A successful response for a `places/within-extent` request. */
    WithinExtentResponse: {
      content: {
        "application/json": {
          results: components["schemas"]["WithinExtentResult"][];
          pagination?: components["schemas"]["Pagination"];
        };
      };
    };
    /** A successful response for a `places/{placeId}` request. */
    PlaceDetailsResponse: {
      content: {
        "application/json": {
          placeDetails: components["schemas"]["PlaceDetails"];
        };
      };
    };
  };
  parameters: {
    /**
     * @description The radius in meters to search for places - measured from the supplied `x` and `y` coordinate.
     *
     * A radius of 100 meters will result in a circular search area that is 200
     * meters in diameter. If omitted, the default search radius will be 1,000
     * meters.
     */
    RadiusParam: components["schemas"]["SearchDistance"];
    /**
     * @description The minimum x coordinate, or longitude, of the search extent, in WGS84 decimal degrees.
     *
     * This is the furthest _west_ that will be searched.
     */
    XMinParam: components["schemas"]["XCoord"];
    /**
     * @description The minimum y coordinate, or latitude, of the search extent, in WGS84 decimal degrees.
     *
     * This is the furthest _south_ that will be searched.
     */
    YMinParam: components["schemas"]["YCoord"];
    /**
     * @description The maximum x coordinate, or longitude, of the search extent, in WGS84 decimal degrees.
     *
     * This is the furthest _east_ that will be searched.
     */
    XMaxParam: components["schemas"]["XCoord"];
    /**
     * @description The maximum y coordinate, or latitude, of the search extent, in WGS84 decimal degrees.
     *
     * This is the furthest _north_ that will be searched.
     */
    YMaxParam: components["schemas"]["YCoord"];
    /**
     * @description Filters places to those that match the category Ids.
     *
     * Places will be returned if they match _any_ of the category Ids. If this
     * property is not set, places will be returned regardless of their
     * category.
     *
     * You can obtain information on category Ids from the
     * `places/categories` endpoint. For example, to filter for places
     * where the category is "Bicycle Store", include the categoryId
     * `17117` in this property.
     *
     * You can search up to a maximum of `10` category Ids.
     */
    CategoryIdsParam: components["schemas"]["CategoryId"][];
    /** @description Free search text for places against names, categories etc. */
    SearchTextParam: string;
    /**
     * @description The number of places that should be sent in the response for a single request.
     *
     * You can set this to any value up to `20` when you need to control the
     * size of responses that your app downloads.
     *
     * If the query results in more than this page size, then the response
     * object will contain a `pagination.nextUrl`. This can be used to request
     * the next page of results.
     *
     * Regardless of paging, the maximum number of places that can be returned
     * in total is `200`.
     *
     * The default `pageSize` is 10.
     */
    PageSizeParam: number;
    /**
     * @description Request results starting from the given offset.
     *
     * This parameter works with the `pageSize` parameter to fetch results from
     * subsequent pages. For example, with a page size of 2, setting the
     * `offset` to `2` would return the 3rd and 4th results.
     *
     * Regardless of paging, the maximum number of places that can be returned
     * in total is `200`.
     */
    OffsetParam: number;
    /** @description The requested response format - either `json` or `pjson` (pretty json). */
    FormatParam: "json" | "pjson";
    /**
     * @description The ID of the category that you want to fetch details for.
     *
     * For example, using a category ID of `13035` would fetch details about
     * the "Coffee Shop" category.
     */
    CategoryIdParam: components["schemas"]["CategoryId"];
    /**
     * @description A text filter that will be used for searching categories.
     *
     * The text must be at least three characters and will be applied as a
     * partial match. For example, using the filter "off" would return
     * categories using the word "Office" as well as those using the word
     * "Coffee".
     */
    CategoriesFilterParam: string;
    /**
     * @description The array of fields that define the attributes to return for a place.
     *
     * Use this parameter to define the attributes you would like returned,
     * for example `requestedFields=name,address:streetAddress`. However, you can also
     * set this value to `requestedFields=all` to return all of the attributes available
     * for a place.
     *
     * The `placeId` attribute is always returned in addition to the other
     * attributes you requested. If a valid attribute value is not available,
     * `null`, or an empty collection, is returned and you are not charged for
     * it. To see the fields and pricing groups they belong to, go to the table
     * above.
     */
    RequestedFieldsParam: (
      | "all"
      | "additionalLocations"
      | "additionalLocations:dropOff"
      | "additionalLocations:frontDoor"
      | "additionalLocations:road"
      | "additionalLocations:roof"
      | "address"
      | "address:adminRegion"
      | "address:censusBlockId"
      | "address:country"
      | "address:designatedMarketArea"
      | "address:extended"
      | "address:locality"
      | "address:neighborhood"
      | "address:poBox"
      | "address:postcode"
      | "address:postTown"
      | "address:region"
      | "address:streetAddress"
      | "categories"
      | "contactInfo"
      | "contactInfo:email"
      | "contactInfo:fax"
      | "contactInfo:telephone"
      | "contactInfo:website"
      | "chains"
      | "description"
      | "hours"
      | "hours:opening"
      | "hours:openingText"
      | "hours:popular"
      | "location"
      | "name"
      | "rating"
      | "rating:price"
      | "rating:user"
      | "socialMedia"
      | "socialMedia:facebookId"
      | "socialMedia:instagram"
      | "socialMedia:twitter"
    )[];
    /**
     * @description The authentication token, created from an ArcGIS Location Platform account, with the `premium:user:places` [privilege](https://developers.arcgis.com/rest/users-groups-and-items/privileges.htm), used to access the Places service.
     *
     * The `token` parameter can be either an API Key or short-lived token. See
     * [ArcGIS security
     * documentation](https://developers.arcgis.com/documentation/mapping-apis-and-services/security/)
     * for more information on authenticating with a token or API key.
     *
     * Alternatively, you can supply a token in the request header with one of
     * the following keys using the "Bearer" scheme:
     *
     * - `Authorization: Bearer <YOUR_TOKEN>`
     * - `X-Esri-Authorization: Bearer <YOUR_TOKEN>`
     */
    TokenParam: string;
    /**
     * @description Determines whether icons are returned and the type of icon to use with a place or category.
     *
     * ![example icon](https://static.arcgis.com/icons/places/Zoo_48.png)
     *
     * Use this parameter to define the type of icon URL for a given place or
     * category. Place icons are available in the following formats:
     *
     * - `svg`
     * - `cim` ([Cartographic Information Model](https://developers.arcgis.com/documentation/glossary/cim-symbol/))
     * - `png` 48 x 48 pixels
     *
     * The SVG and CIM symbols default to 15 x 15 pixels but can be scaled
     * smoothly for display in larger UI elements or to emphasize these
     * features on a map. The PNG icons are provided as 48 x 48 pixels but for
     * map display the recommended size is 16 x 16 pixels.
     *
     * The default is `none` (no icon URL will be returned).
     */
    IconParam: "none" | "svg" | "png" | "cim";
    /**
     * @description Optional case-sensitive parameter to specify the preferred language to
     * use for category names.
     *
     * This query parameter uses language codes to specify the preferred
     * language. If not set, or if no translation is available, the default
     * behavior is to return category names in English.
     *
     * The language codes use the [CLDR](https://cldr.unicode.org/) (Common
     * Locale Data Repository) format string that uses a two letter language
     * code (e.g. "fr" for French) optionally followed by a two letter country
     * code (e.g. "fr-CA" for French in Canada).
     *
     * If an unsupported language code is used, then the service will attempt
     * to fall-back to the closest available language. This is done by
     * stripping regional and extension subtags to find a known language code.
     * For example, French Canadian (`fr-CA`) is unsupported so this falls back
     * to French `fr`.
     *
     * Should the fallback fail, then the service will return category names in
     * the default language `en` for English.
     *
     * Language codes:
     * - English, default US - `en`
     * - French - `fr`
     * - German - `de`
     * - Japanese - `ja`
     * - Portuguese, default Brazil - `pt`
     * - Spanish - `es`
     */
    LanguageParam: "en" | "es" | "de" | "fr" | "ja" | "pt";
  };
}

export interface operations {
  /**
   * A category describes a type of place, such as "movie theater" or "zoo".
   * The places service has over 1,000 categories (or types) of place. The
   * categories fall into ten general groups: Arts and Entertainment, Business
   * and Professional Services, Community and Government, Dining and Drinking,
   * Events, Health and Medicine, Landmarks and Outdoors, Retail, Sports and
   * Recreation, and Travel and Transportation.
   *
   * The categories are organized into a hierarchical system where a general
   * category contains many more detailed variations on the parent category.
   * For example: "Travel and Transportation" (Level 1),
   * "Transport Hub" (Level 2), "Airport" (Level  3) and "Airport Terminal"
   * (Level 4). The hierarchy has up to 5 levels of categories.
   *
   * The table below shows the top-level of categories, along with a
   * selection of level two categories.
   *
   * The `/categories` endpoint fetches the latest set of place categories.
   * The request returns all categories including their label and
   * `categoryId`. You should use this endpoint to fetch the latest set of
   * categories when your app starts up. Each category contains an unique ID
   * that you can use to perform a `near-point` or `within-extent` search.
   *
   * You can also reduce the list to a subset of categories using the
   * `filter` parameter. For example, searching for "coffee" would return
   * categories including:
   *
   * - "Coffee Shop"
   *
   * - "Coffee Roaster"
   *
   * - "Turkish Coffeehouse"
   *
   * |Category Label | Category ID | Level 2|
   * |--- | --- | ---|
   * |Arts and Entertainment | 10000 | Amusement Park (10001), Art Gallery (10004), Casino (10008), Exhibit (10016), Movie Theater (10024), Museum (10027), Stadium (10051), Water Park (10055), Zoo (10056), ...|
   * |Business and Professional Services | 11000 | Construction (11028), Convention Center (11029), Food and Beverage Service (11056), Health and Beauty Service (11061), Industrial Estate (11106), Office (11124), ...|
   * |Community and Government | 12000 | Education (12009), Organization (12082), Government Building (12064), Community Center (12004), Library (12080), Utility Company (12115), ...|
   * |Dining and Drinking | 13000 | Bakery (13002), Bar (13003), Cafe, Coffee, and Tea House (13032), Restaurant (13065, ...|
   * |Event | 14000 |  Conference (14001), Convention (14002), Entertainment Event (14003), Marketplace (14009), ...|
   * |Health and Medicine | 15000 | Dentist (15007), Emergency Service (15008), Hospital (15014), Medical Center (15016), Optometrist (15024), Physician (15027), Veterinarian (15054), ...|
   * |Landmarks and Outdoors | 16000 | Beach (16003), Structure (16007), Campground (16008), Harbor or Marina (16018), Historic and Protected Site (16020), Monument (16026), Nature Preserve (16028), Park (16032), ...|
   * |Retail | 17000 | Arts and Crafts Store (17003), Bookstore (17018), Convenience Store (17029), Department Store (17033)|
   * |Sports and Recreation | 18000 | Athletic Field (18001), Baseball (18002), Basketball (18006), Football (18013), Golf (18016), Gym and Studio (18021), ...|
   * |Travel and Transportation | 19000 | Bike Rental (19002), Cruise (19005), Electric Vehicle Charging Station (19006), Fuel Station (19007), Lodging (19009), Transport Hub (19030), ...|
   *
   * **Note**: Category details are subject to change as new types of places
   * are introduced.
   *
   * **Note**: Query parameters are case-sensitive.
   */
  categoriesGet: {
    parameters: {
      query: {
        /**
         * A text filter that will be used for searching categories.
         *
         * The text must be at least three characters and will be applied as a
         * partial match. For example, using the filter "off" would return
         * categories using the word "Office" as well as those using the word
         * "Coffee".
         */
        filter?: components["parameters"]["CategoriesFilterParam"];
        /**
         * Determines whether icons are returned and the type of icon to use with a place or category.
         *
         * ![example icon](https://static.arcgis.com/icons/places/Zoo_48.png)
         *
         * Use this parameter to define the type of icon URL for a given place or
         * category. Place icons are available in the following formats:
         *
         * - `svg`
         * - `cim` ([Cartographic Information Model](https://developers.arcgis.com/documentation/glossary/cim-symbol/))
         * - `png` 48 x 48 pixels
         *
         * The SVG and CIM symbols default to 15 x 15 pixels but can be scaled
         * smoothly for display in larger UI elements or to emphasize these
         * features on a map. The PNG icons are provided as 48 x 48 pixels but for
         * map display the recommended size is 16 x 16 pixels.
         *
         * The default is `none` (no icon URL will be returned).
         */
        icon?: components["parameters"]["IconParam"];
        /**
         * Optional case-sensitive parameter to specify the preferred language to
         * use for category names.
         *
         * This query parameter uses language codes to specify the preferred
         * language. If not set, or if no translation is available, the default
         * behavior is to return category names in English.
         *
         * The language codes use the [CLDR](https://cldr.unicode.org/) (Common
         * Locale Data Repository) format string that uses a two letter language
         * code (e.g. "fr" for French) optionally followed by a two letter country
         * code (e.g. "fr-CA" for French in Canada).
         *
         * If an unsupported language code is used, then the service will attempt
         * to fall-back to the closest available language. This is done by
         * stripping regional and extension subtags to find a known language code.
         * For example, French Canadian (`fr-CA`) is unsupported so this falls back
         * to French `fr`.
         *
         * Should the fallback fail, then the service will return category names in
         * the default language `en` for English.
         *
         * Language codes:
         * - English, default US - `en`
         * - French - `fr`
         * - German - `de`
         * - Japanese - `ja`
         * - Portuguese, default Brazil - `pt`
         * - Spanish - `es`
         */
        language?: components["parameters"]["LanguageParam"];
        /** The requested response format - either `json` or `pjson` (pretty json). */
        f?: components["parameters"]["FormatParam"];
        /**
         * The authentication token, created from an ArcGIS Location Platform account, with the `premium:user:places` [privilege](https://developers.arcgis.com/rest/users-groups-and-items/privileges.htm), used to access the Places service.
         *
         * The `token` parameter can be either an API Key or short-lived token. See
         * [ArcGIS security
         * documentation](https://developers.arcgis.com/documentation/mapping-apis-and-services/security/)
         * for more information on authenticating with a token or API key.
         *
         * Alternatively, you can supply a token in the request header with one of
         * the following keys using the "Bearer" scheme:
         *
         * - `Authorization: Bearer <YOUR_TOKEN>`
         * - `X-Esri-Authorization: Bearer <YOUR_TOKEN>`
         */
        token?: components["parameters"]["TokenParam"];
      };
    };
    responses: {
      200: components["responses"]["CategoriesDetailsResponse"];
      400: components["responses"]["InvalidQueryErrorResponse"];
      401: components["responses"]["UnauthorizedErrorResponse"];
      403: components["responses"]["PermissionMissingErrorResponse"];
      "5XX": components["responses"]["ServerErrorResponse"];
    };
  };
  /**
   * The `/categories/{categoryId}` request returns all the groups to which the category belongs. You must supply a `category ID` to use this request.
   *
   * **Note**: Query parameters are case-sensitive.
   */
  categoriesCategoryIdGet: {
    parameters: {
      path: {
        /**
         * The ID of the category that you want to fetch details for.
         *
         * For example, using a category ID of `13035` would fetch details about
         * the "Coffee Shop" category.
         */
        categoryId: components["parameters"]["CategoryIdParam"];
      };
      query: {
        /**
         * Determines whether icons are returned and the type of icon to use with a place or category.
         *
         * ![example icon](https://static.arcgis.com/icons/places/Zoo_48.png)
         *
         * Use this parameter to define the type of icon URL for a given place or
         * category. Place icons are available in the following formats:
         *
         * - `svg`
         * - `cim` ([Cartographic Information Model](https://developers.arcgis.com/documentation/glossary/cim-symbol/))
         * - `png` 48 x 48 pixels
         *
         * The SVG and CIM symbols default to 15 x 15 pixels but can be scaled
         * smoothly for display in larger UI elements or to emphasize these
         * features on a map. The PNG icons are provided as 48 x 48 pixels but for
         * map display the recommended size is 16 x 16 pixels.
         *
         * The default is `none` (no icon URL will be returned).
         */
        icon?: components["parameters"]["IconParam"];
        /**
         * Optional case-sensitive parameter to specify the preferred language to
         * use for category names.
         *
         * This query parameter uses language codes to specify the preferred
         * language. If not set, or if no translation is available, the default
         * behavior is to return category names in English.
         *
         * The language codes use the [CLDR](https://cldr.unicode.org/) (Common
         * Locale Data Repository) format string that uses a two letter language
         * code (e.g. "fr" for French) optionally followed by a two letter country
         * code (e.g. "fr-CA" for French in Canada).
         *
         * If an unsupported language code is used, then the service will attempt
         * to fall-back to the closest available language. This is done by
         * stripping regional and extension subtags to find a known language code.
         * For example, French Canadian (`fr-CA`) is unsupported so this falls back
         * to French `fr`.
         *
         * Should the fallback fail, then the service will return category names in
         * the default language `en` for English.
         *
         * Language codes:
         * - English, default US - `en`
         * - French - `fr`
         * - German - `de`
         * - Japanese - `ja`
         * - Portuguese, default Brazil - `pt`
         * - Spanish - `es`
         */
        language?: components["parameters"]["LanguageParam"];
        /** The requested response format - either `json` or `pjson` (pretty json). */
        f?: components["parameters"]["FormatParam"];
        /**
         * The authentication token, created from an ArcGIS Location Platform account, with the `premium:user:places` [privilege](https://developers.arcgis.com/rest/users-groups-and-items/privileges.htm), used to access the Places service.
         *
         * The `token` parameter can be either an API Key or short-lived token. See
         * [ArcGIS security
         * documentation](https://developers.arcgis.com/documentation/mapping-apis-and-services/security/)
         * for more information on authenticating with a token or API key.
         *
         * Alternatively, you can supply a token in the request header with one of
         * the following keys using the "Bearer" scheme:
         *
         * - `Authorization: Bearer <YOUR_TOKEN>`
         * - `X-Esri-Authorization: Bearer <YOUR_TOKEN>`
         */
        token?: components["parameters"]["TokenParam"];
      };
    };
    responses: {
      200: components["responses"]["CategoryDetailsResponse"];
      400: components["responses"]["InvalidQueryErrorResponse"];
      401: components["responses"]["UnauthorizedErrorResponse"];
      403: components["responses"]["PermissionMissingErrorResponse"];
      404: components["responses"]["IdNotFoundErrorResponse"];
      "5XX": components["responses"]["ServerErrorResponse"];
    };
  };
  /**
   * The `/places/near-point` request finds places that are within a given
   * radius of a specified location. The returned places contain basic data
   * such as name, category and location.
   *
   * To perform the request, you must supply the `x` and `y` coordinates of
   * the point from which to search. Optionally, you can also specify the:
   *
   * - Search radius (1 to 10,000 meters)
   * - Category IDs
   * - Search text
   *
   * If the `pagination.nextUrl` property in the response is populated, then
   * you can page through the results to return more places. The maximum
   * number of places that can be paged to is 200.
   *
   * **Note**: You cannot permanently store places. Please see the [Terms of
   * use](https://developers.arcgis.com/documentation/mapping-apis-and-services/deployment/terms-of-use/).
   *
   * **Note**: Query parameters are case-sensitive.
   */
  nearPointGet: {
    parameters: {
      query: {
        /** The x coordinate, or longitude, to search from, in WGS84 decimal degrees. */
        x: components["schemas"]["XCoord"];
        /** The y coordinate, or latitude, to search from, in WGS84 decimal degrees. */
        y: components["schemas"]["YCoord"];
        /**
         * The radius in meters to search for places - measured from the supplied `x` and `y` coordinate.
         *
         * A radius of 100 meters will result in a circular search area that is 200
         * meters in diameter. If omitted, the default search radius will be 1,000
         * meters.
         */
        radius?: components["parameters"]["RadiusParam"];
        /**
         * Filters places to those that match the category Ids.
         *
         * Places will be returned if they match _any_ of the category Ids. If this
         * property is not set, places will be returned regardless of their
         * category.
         *
         * You can obtain information on category Ids from the
         * `places/categories` endpoint. For example, to filter for places
         * where the category is "Bicycle Store", include the categoryId
         * `17117` in this property.
         *
         * You can search up to a maximum of `10` category Ids.
         */
        categoryIds?: components["parameters"]["CategoryIdsParam"];
        /** Free search text for places against names, categories etc. */
        searchText?: components["parameters"]["SearchTextParam"];
        /**
         * The number of places that should be sent in the response for a single request.
         *
         * You can set this to any value up to `20` when you need to control the
         * size of responses that your app downloads.
         *
         * If the query results in more than this page size, then the response
         * object will contain a `pagination.nextUrl`. This can be used to request
         * the next page of results.
         *
         * Regardless of paging, the maximum number of places that can be returned
         * in total is `200`.
         *
         * The default `pageSize` is 10.
         */
        pageSize?: components["parameters"]["PageSizeParam"];
        /**
         * Determines whether icons are returned and the type of icon to use with a place or category.
         *
         * ![example icon](https://static.arcgis.com/icons/places/Zoo_48.png)
         *
         * Use this parameter to define the type of icon URL for a given place or
         * category. Place icons are available in the following formats:
         *
         * - `svg`
         * - `cim` ([Cartographic Information Model](https://developers.arcgis.com/documentation/glossary/cim-symbol/))
         * - `png` 48 x 48 pixels
         *
         * The SVG and CIM symbols default to 15 x 15 pixels but can be scaled
         * smoothly for display in larger UI elements or to emphasize these
         * features on a map. The PNG icons are provided as 48 x 48 pixels but for
         * map display the recommended size is 16 x 16 pixels.
         *
         * The default is `none` (no icon URL will be returned).
         */
        icon?: components["parameters"]["IconParam"];
        /**
         * Request results starting from the given offset.
         *
         * This parameter works with the `pageSize` parameter to fetch results from
         * subsequent pages. For example, with a page size of 2, setting the
         * `offset` to `2` would return the 3rd and 4th results.
         *
         * Regardless of paging, the maximum number of places that can be returned
         * in total is `200`.
         */
        offset?: components["parameters"]["OffsetParam"];
        /** The requested response format - either `json` or `pjson` (pretty json). */
        f?: components["parameters"]["FormatParam"];
        /**
         * The authentication token, created from an ArcGIS Location Platform account, with the `premium:user:places` [privilege](https://developers.arcgis.com/rest/users-groups-and-items/privileges.htm), used to access the Places service.
         *
         * The `token` parameter can be either an API Key or short-lived token. See
         * [ArcGIS security
         * documentation](https://developers.arcgis.com/documentation/mapping-apis-and-services/security/)
         * for more information on authenticating with a token or API key.
         *
         * Alternatively, you can supply a token in the request header with one of
         * the following keys using the "Bearer" scheme:
         *
         * - `Authorization: Bearer <YOUR_TOKEN>`
         * - `X-Esri-Authorization: Bearer <YOUR_TOKEN>`
         */
        token?: components["parameters"]["TokenParam"];
      };
    };
    responses: {
      200: components["responses"]["NearPointResponse"];
      400: components["responses"]["InvalidQueryErrorResponse"];
      401: components["responses"]["UnauthorizedErrorResponse"];
      403: components["responses"]["PermissionMissingErrorResponse"];
      "5XX": components["responses"]["ServerErrorResponse"];
    };
  };
  /**
   * The `/places/within-extent` request searches for places within an extent (bounding box).
   *
   * You must supply the `xmin`, `ymin`, `xmax` and `ymax` coordinates to
   * define the extent. The maximum width and height of an extent that can be
   * used in a search is 20,000 meters. The width and height of an extent
   * must be greater than 0 meters.
   *
   * You can also provide multiple categories or search text to find specific
   * types of places within the extent.
   *
   * The default number of places returned (`pageSize`) is 10. The maximum
   * `pageSize` value is 20.
   *
   * If the `pagination.nextUrl` property in the response is populated, then
   * you can page through the results to return more places. The maximum
   * number of places that can be paged to is 200.
   *
   * **Note**: You cannot permanently store places. Please see the [Terms of
   * use](https://developers.arcgis.com/documentation/mapping-apis-and-services/deployment/terms-of-use/).
   *
   * **Note**: Query parameters are case-sensitive.
   */
  withinExtentGet: {
    parameters: {
      query: {
        /**
         * The minimum x coordinate, or longitude, of the search extent, in WGS84 decimal degrees.
         *
         * This is the furthest _west_ that will be searched.
         */
        xmin: components["parameters"]["XMinParam"];
        /**
         * The minimum y coordinate, or latitude, of the search extent, in WGS84 decimal degrees.
         *
         * This is the furthest _south_ that will be searched.
         */
        ymin: components["parameters"]["YMinParam"];
        /**
         * The maximum x coordinate, or longitude, of the search extent, in WGS84 decimal degrees.
         *
         * This is the furthest _east_ that will be searched.
         */
        xmax: components["parameters"]["XMaxParam"];
        /**
         * The maximum y coordinate, or latitude, of the search extent, in WGS84 decimal degrees.
         *
         * This is the furthest _north_ that will be searched.
         */
        ymax: components["parameters"]["YMaxParam"];
        /**
         * Filters places to those that match the category Ids.
         *
         * Places will be returned if they match _any_ of the category Ids. If this
         * property is not set, places will be returned regardless of their
         * category.
         *
         * You can obtain information on category Ids from the
         * `places/categories` endpoint. For example, to filter for places
         * where the category is "Bicycle Store", include the categoryId
         * `17117` in this property.
         *
         * You can search up to a maximum of `10` category Ids.
         */
        categoryIds?: components["parameters"]["CategoryIdsParam"];
        /** Free search text for places against names, categories etc. */
        searchText?: components["parameters"]["SearchTextParam"];
        /**
         * Determines whether icons are returned and the type of icon to use with a place or category.
         *
         * ![example icon](https://static.arcgis.com/icons/places/Zoo_48.png)
         *
         * Use this parameter to define the type of icon URL for a given place or
         * category. Place icons are available in the following formats:
         *
         * - `svg`
         * - `cim` ([Cartographic Information Model](https://developers.arcgis.com/documentation/glossary/cim-symbol/))
         * - `png` 48 x 48 pixels
         *
         * The SVG and CIM symbols default to 15 x 15 pixels but can be scaled
         * smoothly for display in larger UI elements or to emphasize these
         * features on a map. The PNG icons are provided as 48 x 48 pixels but for
         * map display the recommended size is 16 x 16 pixels.
         *
         * The default is `none` (no icon URL will be returned).
         */
        icon?: components["parameters"]["IconParam"];
        /**
         * The number of places that should be sent in the response for a single request.
         *
         * You can set this to any value up to `20` when you need to control the
         * size of responses that your app downloads.
         *
         * If the query results in more than this page size, then the response
         * object will contain a `pagination.nextUrl`. This can be used to request
         * the next page of results.
         *
         * Regardless of paging, the maximum number of places that can be returned
         * in total is `200`.
         *
         * The default `pageSize` is 10.
         */
        pageSize?: components["parameters"]["PageSizeParam"];
        /**
         * Request results starting from the given offset.
         *
         * This parameter works with the `pageSize` parameter to fetch results from
         * subsequent pages. For example, with a page size of 2, setting the
         * `offset` to `2` would return the 3rd and 4th results.
         *
         * Regardless of paging, the maximum number of places that can be returned
         * in total is `200`.
         */
        offset?: components["parameters"]["OffsetParam"];
        /** The requested response format - either `json` or `pjson` (pretty json). */
        f?: components["parameters"]["FormatParam"];
        /**
         * The authentication token, created from an ArcGIS Location Platform account, with the `premium:user:places` [privilege](https://developers.arcgis.com/rest/users-groups-and-items/privileges.htm), used to access the Places service.
         *
         * The `token` parameter can be either an API Key or short-lived token. See
         * [ArcGIS security
         * documentation](https://developers.arcgis.com/documentation/mapping-apis-and-services/security/)
         * for more information on authenticating with a token or API key.
         *
         * Alternatively, you can supply a token in the request header with one of
         * the following keys using the "Bearer" scheme:
         *
         * - `Authorization: Bearer <YOUR_TOKEN>`
         * - `X-Esri-Authorization: Bearer <YOUR_TOKEN>`
         */
        token?: components["parameters"]["TokenParam"];
      };
    };
    responses: {
      200: components["responses"]["WithinExtentResponse"];
      400: components["responses"]["InvalidQueryErrorResponse"];
      401: components["responses"]["UnauthorizedErrorResponse"];
      403: components["responses"]["PermissionMissingErrorResponse"];
      "5XX": components["responses"]["ServerErrorResponse"];
    };
  };
  /**
   * The `/places/{placeId}` request returns details for a place.
   *
   * To request details, you use the `requestedFields` parameter to specify
   * the fields and the attributes you want from the **Place**,
   * **Address**, **Details** and/or **Location** price groups.
   *
   * It is always recommended to specify the fields you want, however, you
   * can also use `requestedFields=all` to return all of the attributes
   * available. By default, The `placeId` attribute is always returned in addition
   * to the other attributes you requested.
   *
   * The attributes available for places may vary. For example, opening hours
   * may not be available (or applicable) for geographic places or landmarks.
   *
   * You will only be charged for attributes that contain valid values for
   * the requested fields. If no data is available for the requested field,
   * `null` or an empty collection  is returned and you are not charged. You
   * are only charged once if one or more attributes with valid values are
   * returned from a price group. To learn more, go to
   * [Pricing](https://developers.arcgis.com/pricing/).
   *
   * Field | Price group
   * --- | ---
   * additionalLocations:dropOff | Location
   * additionalLocations:frontDoor | Location
   * additionalLocations:road | Location
   * additionalLocations:roof | Location
   * address:adminRegion | Address
   * address:censusBlockId | Address
   * address:country | Address
   * address:designatedMarketArea | Address
   * address:extended | Address
   * address:locality | Address
   * address:neighborhood | Address
   * address:poBox | Address
   * address:postcode | Address
   * address:postTown | Address
   * address:region | Address
   * address:streetAddress | Address
   * categories | Place
   * chains | Details
   * contactInfo:email | Details
   * contactInfo:fax | Details
   * contactInfo:telephone | Details
   * contactInfo:website | Details
   * description | Details
   * hours:opening | Details
   * hours:openingText | Details
   * hours:popular | Details
   * location | Location
   * name | Place
   * rating:price | Details
   * rating:user | Details
   * socialMedia:facebookId | Details
   * socialMedia:instagram | Details
   * socialMedia:twitter | Details
   *
   * **Note**: You cannot permanently store places. Please see the [Terms of
   * use](https://developers.arcgis.com/documentation/mapping-apis-and-services/deployment/terms-of-use/).
   *
   * **Note**: Query parameters are case-sensitive.
   *
   * **Note**: Can be used in conjunction with the [Basemap Styles service](https://developers.arcgis.com/rest/basemap-styles) to request additional attributes
   * for places retrieved using the [Places for basemaps](https://developers.arcgis.com/documentation/mapping-apis-and-services/maps/places-for-basemaps) workflow.
   */
  placeIdGet: {
    parameters: {
      path: {
        /** The Id of the place for which you want to fetch additional details. */
        placeId: components["schemas"]["PlaceId"];
      };
      query: {
        /**
         * The array of fields that define the attributes to return for a place.
         *
         * Use this parameter to define the attributes you would like returned,
         * for example `requestedFields=name,address:streetAddress`. However, you can also
         * set this value to `requestedFields=all` to return all of the attributes available
         * for a place.
         *
         * The `placeId` attribute is always returned in addition to the other
         * attributes you requested. If a valid attribute value is not available,
         * `null`, or an empty collection, is returned and you are not charged for
         * it. To see the fields and pricing groups they belong to, go to the table
         * above.
         */
        requestedFields: components["parameters"]["RequestedFieldsParam"];
        /**
         * Determines whether icons are returned and the type of icon to use with a place or category.
         *
         * ![example icon](https://static.arcgis.com/icons/places/Zoo_48.png)
         *
         * Use this parameter to define the type of icon URL for a given place or
         * category. Place icons are available in the following formats:
         *
         * - `svg`
         * - `cim` ([Cartographic Information Model](https://developers.arcgis.com/documentation/glossary/cim-symbol/))
         * - `png` 48 x 48 pixels
         *
         * The SVG and CIM symbols default to 15 x 15 pixels but can be scaled
         * smoothly for display in larger UI elements or to emphasize these
         * features on a map. The PNG icons are provided as 48 x 48 pixels but for
         * map display the recommended size is 16 x 16 pixels.
         *
         * The default is `none` (no icon URL will be returned).
         */
        icon?: components["parameters"]["IconParam"];
        /** The requested response format - either `json` or `pjson` (pretty json). */
        f?: components["parameters"]["FormatParam"];
        /**
         * The authentication token, created from an ArcGIS Location Platform account, with the `premium:user:places` [privilege](https://developers.arcgis.com/rest/users-groups-and-items/privileges.htm), used to access the Places service.
         *
         * The `token` parameter can be either an API Key or short-lived token. See
         * [ArcGIS security
         * documentation](https://developers.arcgis.com/documentation/mapping-apis-and-services/security/)
         * for more information on authenticating with a token or API key.
         *
         * Alternatively, you can supply a token in the request header with one of
         * the following keys using the "Bearer" scheme:
         *
         * - `Authorization: Bearer <YOUR_TOKEN>`
         * - `X-Esri-Authorization: Bearer <YOUR_TOKEN>`
         */
        token?: components["parameters"]["TokenParam"];
      };
    };
    responses: {
      200: components["responses"]["PlaceDetailsResponse"];
      400: components["responses"]["InvalidQueryErrorResponse"];
      401: components["responses"]["UnauthorizedErrorResponse"];
      403: components["responses"]["PermissionMissingErrorResponse"];
      404: components["responses"]["IdNotFoundErrorResponse"];
      "5XX": components["responses"]["ServerErrorResponse"];
    };
  };
}

export interface external {}
